import { render, staticRenderFns } from "./GamePreviewSetting.vue?vue&type=template&id=d83856b4&scoped=true&lang=pug&"
import script from "./GamePreviewSetting.vue?vue&type=script&lang=js&"
export * from "./GamePreviewSetting.vue?vue&type=script&lang=js&"
import style0 from "./GamePreviewSetting.vue?vue&type=style&index=0&id=d83856b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83856b4",
  null
  
)

export default component.exports